// extracted by mini-css-extract-plugin
module.exports = {"root":"_3pAUKGcHojT4fUg3WoKbcM","hidden":"_27GWp3lOxMHlRAqVKL3w6g"};